var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.84 4.49002H13.25V2.10502C12.5673 2.03403 11.8814 1.99898 11.195 2.00002C9.155 2.00002 7.76 3.24502 7.76 5.52502V7.49002H5.4575V10.16H7.76V17H10.52V10.16H12.815L13.16 7.49002H10.52V5.78752C10.52 5.00002 10.73 4.49002 11.84 4.49002Z",
    fill: "#F0F6FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.bdc60375d9156202702200dd5387ad4e.svg";
export { ForwardRef as ReactComponent };